import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import GameCard from '../components/GameCard';
import DashboardSlider from '../components/DashboardSlider';
import { Gamepad2 , ChevronLeft  } from 'lucide-react';
import BackButton from '../components/BackButton';

export default function Favorites() {
  const [games, setGames] = useState([]);
  const [selectedGame, setSelectedGame] = useState(null);

  useEffect(() => {
    const storedGames = localStorage.getItem('GB_Favorites');
    if (storedGames) {
      try {
        const parsedGames = JSON.parse(storedGames);
        if (Array.isArray(parsedGames) && parsedGames.length > 0) {
          setGames(parsedGames);
        }
      } catch (error) {
        console.error('Failed to parse games data:', error);
      }
    }
  }, []);

  const handleGameSelect = (game) => {
    setSelectedGame(game);
  };

  return (
    <div>
      <Sidebar />
      <div className="main-body">
         <BackButton/>
        <h4 className='my-3'><strong>Your Favorite Games</strong></h4>

        {games.length === 0 ? (
          <div className='notfound mt-5' >
            <Gamepad2 size={100}/>

            <h4 style={{color:'var(--main-red)'}} >No favorite games found.</h4>
            <p>No favorite games found. Go to the home screen to add games to your favorites list</p>
            <button className='btn btn-primary' onClick={()=>window.location.href='/dashboard/home'}>
            <ChevronLeft />Home Page</button>
          </div>
        ) : (
          <>
            {selectedGame?.Title && (
              <DashboardSlider game={selectedGame} />
            )}

            <div className='games_grid mt-3'>
              {games.map((game, index) => (
                <GameCard key={index} game={game} onInfoClick={handleGameSelect} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
